'use client';

import { c as _c } from "react/compiler-runtime";
import { SKUSelectionErrorMessageDefaults } from '@src/components/SKUSelectionErrorMessage/SKUSelectionErrorMessage.defaults';
import type { SKUSelectionErrorMessageProps } from '@src/components/SKUSelectionErrorMessage/SKUSelectionErrorMessage.props';
import { isSelectionStateValid, useSKUSelectionStore } from '@src/stores/SKUSelectionStore';
export const SKUSelectionErrorMessage = t0 => {
  const $ = _c(2);
  const props = t0 === undefined ? SKUSelectionErrorMessageDefaults : t0;
  const {
    errorMessage
  } = props;
  const groups = useSKUSelectionStore(_temp);
  const groupRestrictions = useSKUSelectionStore(_temp2);
  const isValid = isSelectionStateValid(groups, groupRestrictions);
  if (isValid) {
    return null;
  }
  const t1 = errorMessage ?? "";
  let t2;
  if ($[0] !== t1) {
    t2 = <div className="text-body-md" dangerouslySetInnerHTML={{
      __html: t1
    }} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
function _temp(state) {
  return state.groups;
}
function _temp2(state_0) {
  return state_0.groupRestrictions;
}